export default __webpack_public_path__ + "static/media/Roboto-Bold.c477ec32.ttf";